import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { CarouselComponent, OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-smartest-way',
  templateUrl: './smartest-way.component.html',
  styleUrls: ['./smartest-way.component.scss']
})
export class SmartestWayComponent implements OnInit, AfterViewInit {
 

  @ViewChild('owlCar') carousel: any;

  smart_way_one =[
    {
      no:"1",
      para:"smart_way_1",
    },
    {
      no:"2",
      para:"smart_way_2",
    },
    {
      no:"3",
      para:"smart_way_3",
    },
    {
      no:"4",
      para:"smart_way_4",
    },
  ]
  smart_way_two =[
    {
      no:"5",
      para:"smart_way_5",
    },
    {
      no:"6",
      para:"smart_way_6",
    },
    {
      no:"7",
      para:"smart_way_7",
    },
    {
      no:"8",
      para:"smart_way_8",
    },
  ]

smart_way = [
  {
    no:"1",
    para:"smart_way_1",
  },
  {
    no:"2",
    para:"smart_way_2",
  },
  {
    no:"3",
    para:"smart_way_3",
  },
  {
    no:"4",
    para:"smart_way_4",
  },
  {
    no:"5",
    para:"smart_way_5",
  },
  {
    no:"6",
    para:"smart_way_6",
  },
  {
    no:"7",
    para:"smart_way_7",
  },
  {
    no:"8",
    para:"smart_way_8",
  },
]
smartest: OwlOptions = {
  loop: false,
  dots: false,
  mouseDrag: true,
  touchDrag: true,
  pullDrag: true,
  // autoplaySpeed: 1000,
  smartSpeed: 300, 
  margin:20,
  // animateOut: 'fadeOut', 
  // animateIn: 'fadeIn',
  nav:true,
 
  center:false,
  items: 2,
  stagePadding: 30,
  navText: [
    "<img src='/assets/images/prev-arrow.svg'>",
    "<img src='/assets/images/next-arrow.svg'>",
  ],

};
activeSlide: number = 1;
startPosition: boolean = true;
  OwlOptions: any;




ngAfterViewInit() {
  console.log(this.carousel);
}


getPassedData(data: SlidesOutputData) {
  const active = data.startPosition || 0;
  this.activeSlide = active + 1
}


  navigateToSection(hashKey: string) {
    throw new Error('Method not implemented.');
  }
  scrollTop(){
    window.scrollTo(0, 0);
  }

  selectTo(owlCar: any){
    console.log('ON SELECT TO ----->>', owlCar?.slidesOutputData?.startPosition);
 
    this.startPosition = (this.smart_way.length - 3) >= owlCar?.slidesOutputData?.startPosition ? true : false;
    console.log('this.startPosition ------------->>', this.startPosition);
    
    
    // this.curIndx = moveNext ? this.curIndx < this.timeline.length - 1 ?   this.curIndx + 1 : this.timeline.length - 1 :  this.curIndx > 0 ? this.curIndx - 1 : 0;
    // owlCar.to(this.curIndx.toString());
    // this.setActiveClass(this.timeline[this.curIndx].title);
  }

  ngOnInit(): void {
  
  }
}
